export enum UserConnexionMethod {
	AUTOMATIC = "AUTOMATIC",
	MANUAL = "MANUAL",
	NONE = "NONE",
}
